export const ValidRegex = {
  EMAIL_REGEX: /^(?!.*@.*\.localhost$)[A-Z0-9_+%-]+(?:\.[A-Z0-9_+%-]+)*@(?:[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}$/i,

  // Patterns for Text (Multi Line) fields. Validators.pattern() compiles a string
  // pattern as `^<pattern>$` with no flags, and in JavaScript `.` never matches a
  // line break. So a multi-line pattern has to spell out the newline characters a
  // <textarea> can hold, otherwise every value with a line break fails validation.
  MULTI_LINE_ALL_CHARS_PATTERN: "[\\s\\S]*",
  MULTI_LINE_ALPHABET_PATTERN: "^[a-zA-Z \\r\\n]*$",
  MULTI_LINE_ALPHA_NUMERIC_PATTERN: "^[a-zA-Z0-9 \\r\\n]*$"
};
